"use client";

import { Building2, TrendingUp, Shield } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function InvestmentStrategy() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const strategies = [{
    icon: Building2,
    title: "Purpose-Built Properties",
    description: "We develop turn-key assets designed exclusively for triple-net tenants in highly regulated industries, ensuring long-term stability and predictable cash flows.",
    ref: ref1,
    isVisible: isVisible1,
    delay: "0ms"
  }, {
    icon: TrendingUp,
    title: "Risk-Adjusted Returns",
    description: "Our disciplined underwriting process targets value-creation strategies that maximize risk-adjusted returns while maintaining strict investment criteria.",
    ref: ref2,
    isVisible: isVisible2,
    delay: "150ms"
  }, {
    icon: Shield,
    title: "Regulated Sector Focus",
    description: "By concentrating on highly regulated industries, we capture premium lease rates and benefit from structural barriers to entry that protect tenant stability.",
    ref: ref3,
    isVisible: isVisible3,
    delay: "300ms"
  }];
  return <section className="bg-dark-background py-24">
      <div className="mx-auto max-w-7xl px-6">
        <div className="grid gap-8 md:grid-cols-3">
          {strategies.map((strategy, i) => {
          const Icon = strategy.icon;
          return <div key={i} data-index={i} ref={strategy.ref} style={{
            opacity: strategy.isVisible ? 1 : 0,
            transform: strategy.isVisible ? "translateY(0)" : "translateY(2rem)",
            transition: `opacity 600ms ease-out ${strategy.delay}, transform 600ms cubic-bezier(0.34, 1.56, 0.64, 1) ${strategy.delay}`
          }} className="group flex flex-col items-start gap-4 rounded-lg bg-dark-background/40 p-8 shadow-soft backdrop-blur-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-[inset_0_0_32px_rgba(255,255,255,0.08)] hover:shadow-medium">
                <div className="flex h-16 w-16 items-center justify-center rounded-full bg-primary/10 text-primary transition-colors duration-300 group-hover:bg-primary/20">
                  <Icon className="h-8 w-8" strokeWidth={1.5} />
                </div>
                <h3 className="font-display text-xl font-semibold text-foreground-dark">
                  {strategy.title}
                </h3>
                <p className="text-sm leading-relaxed text-foreground-dark/80">
                  {strategy.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}